<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="75%">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0" primary-title>
          Novo Sql
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-text-field 
            v-model="newSql.Descricao" 
            label="Descrição do sql"
            @keyup.enter="adiciona"
            autofocus
            outline
            spellcheck="false"
          ></v-text-field>
          <SharedTextarea
            :value="newSql.InstrucaoSql"
            @change="v => newSql.InstrucaoSql = v"
            label="Instrução Sql" 
            hide-details
            outline
            spellcheck="false"
            class="font-code"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Sql from '@/domain/sql/Sql';
import SharedTextarea from '@/components/shared/Textarea';

export default {
  name: 'ModalCadastroSql',
  props: ['value'],
  components: {
    SharedTextarea
  },
  data() {
    return {
      loading: false,
      newSql: new Sql()
    }
  },
  methods: {
    ...mapActions(['addSql']),
    ...mapMutations(['showNotification', 'closeNotification']),
    async adiciona() {
      if (this.newSql.Descricao) {
        this.loading = true;
        try {
          await this.addSql(this.newSql);
          this.showNotification({ text: `Sql: ${this.newSql.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.newSql = new Sql();
          this.$emit('input');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o sql: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do sql.`, status: 'error' });
      }
    }
  }
}
</script>

<style>
.font-code {
  font-family: 'Courier New', Courier, monospace;
}
</style>
